var map = {
	"./Ubisoft-plus-mouse-icon.svg": 41,
	"./Ubisoft-plus-mouse-icon_emea.svg": 42,
	"./Ubisoft-plus-open-lock-icon.svg": 43,
	"./Ubisoft-plus-quality-badge-icon.svg": 44,
	"./Ubisoft-plus-star-icon.svg": 45,
	"./Ubisoft-plus-wings-icon.svg": 46,
	"./Ubisoft-plus-wings-icon_emea.svg": 47,
	"./play-button.svg": 48,
	"./slidernav_left.svg": 49,
	"./slidernav_right.svg": 50,
	"./ubisoft_plus_logo.svg": 17,
	"./uplayplus-ico-download.svg": 51,
	"./uplayplus-ico-earlyaccess.svg": 52,
	"./uplayplus-ico-newreleases.svg": 53,
	"./uplayplus-ico-playtrailer.svg": 54,
	"./uplayplus-ico-plus.svg": 55,
	"./uplayplus-ico-premium.svg": 56,
	"./uplayplus-logo-whtblue.svg": 57
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;